exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;font-family:Open Sans;font-weight:700;font-size:1rem;margin-bottom:1rem}:host .sort-block{padding:0;margin:0}:host .sort-block label{word-spacing:.1em;font-weight:600;border:0;background-color:initial}:host .sort-block select{border-radius:0}@media screen and (min-width:768px){:host{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/home/mes-dossiers/mobile-sort-block/mobile-sort-block.component.scss
// module id = 695
// module chunks = 0